import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { purgeStalebannerKeys } from "@/lib/banner-versions";
import {
  attemptRecoveryReload,
} from "@/lib/chunk-recovery";

purgeStalebannerKeys();

window.addEventListener("vite:preloadError", (event) => {
  if (attemptRecoveryReload()) event.preventDefault();
});

if (import.meta.env.DEV) {
  import("@/lib/dev-reconnect").then(({ startDevReconnectWatcher }) => {
    startDevReconnectWatcher();
  });
}

console.log(
  "%c Welcome to The Carry Network. GLHF.",
  "color:#E8184A;font-weight:bold;font-size:14px;letter-spacing:0.05em;"
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Registration failures are non-fatal; the app still works without the SW
    });
  });
}

createRoot(document.getElementById("root")!).render(<App />);
